// V17.523 (Phase 1): the signed-in user as the menu sees them. Reads AuthContext, so switching
// role in the sidebar's SidebarRoleControl (V17.539; new token → new permissions) changes the menu at once (B2b).
import { useMemo } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import type { NavUser } from './navModel';

export function useNavUser(): NavUser {
  const { user, permissions } = useAuth();
  return useMemo(() => {
    const names = new Set<string>();
    if (user?.role_name) names.add(user.role_name);
    for (const n of user?.all_role_names ?? []) names.add(n);
    return { permissions, roleAssignments: [...names], role: user?.role ?? null };
  }, [user, permissions]);
}
